import React, { useId } from "react";
import { useT } from "../../i18n/useT";
import { getCurrentLocale } from "../../utlis/locale";

export default function DiagnosisDateField({
  value,
  onChange,
  disabled = false,
  invalid = false,
}) {
  const t = useT("testPersonForm");
  const id = useId();
  const japanese = getCurrentLocale() === "ja";
  const format = japanese ? "YYYY/MM/DD" : "MM/DD/YYYY";
  // Keep date-only values out of Date/UTC conversion to avoid day shifts.
  const [year, month, day] = value ? value.split("-") : [];
  const display = value
    ? japanese
      ? `${year}/${month}/${day}`
      : `${month}/${day}/${year}`
    : format;

  const openPicker = (event) => {
    // Older iPad WebViews use the input's built-in picker on tap/focus.
    try {
      event.currentTarget.showPicker?.();
    } catch {
      // The native input remains usable where showPicker isn't available.
    }
  };

  return (
    <div className="mmt-field">
      <label htmlFor={id}>
        <span>{t("diagnosis_date")}</span>
      </label>
      <div className="mmt-diagnosis-date-row">
        <div
          className={`mmt-diagnosis-date${disabled ? " is-disabled" : ""}${invalid ? " mmt-input-error" : ""}`}
        >
          {/* The native calendar handles selection; the overlay guarantees the
              app's format even when the device's date order is different. */}
          <input
            id={id}
            type="date"
            lang={japanese ? "ja-JP" : "en-US"}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            onClick={openPicker}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                openPicker(event);
              }
            }}
            disabled={disabled}
            aria-invalid={invalid || undefined}
          />
          <div className="mmt-diagnosis-date-display" aria-hidden="true">
            <span className={value ? "" : "is-placeholder"}>{display}</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="5" width="18" height="16" rx="2" />
              <path d="M16 3v4M8 3v4M3 11h18" />
            </svg>
          </div>
        </div>
        {value && !disabled ? (
          <button
            type="button"
            className="mmt-diagnosis-date-clear"
            aria-label={t("clear_diagnosis_date")}
            onClick={() => onChange("")}
          >
            ×
          </button>
        ) : null}
      </div>
    </div>
  );
}
